import { default as directfIc4JQFEtcMeta } from "/tmp/build/d411e185/code/pages/[slug]/direct.vue?macro=true";
import { default as indexenuCsulzJFMeta } from "/tmp/build/d411e185/code/pages/[slug]/index.vue?macro=true";
import { default as processingragpXmuMELMeta } from "/tmp/build/d411e185/code/pages/[slug]/processing.vue?macro=true";
import { default as summarymfuZHB64tAMeta } from "/tmp/build/d411e185/code/pages/[slug]/summary.vue?macro=true";
export default [
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___en",
    path: directfIc4JQFEtcMeta?.path ?? "/en/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___pt",
    path: directfIc4JQFEtcMeta?.path ?? "/pt/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___ca",
    path: directfIc4JQFEtcMeta?.path ?? "/ca/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___es",
    path: directfIc4JQFEtcMeta?.path ?? "/es/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___fr",
    path: directfIc4JQFEtcMeta?.path ?? "/fr/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___it",
    path: directfIc4JQFEtcMeta?.path ?? "/it/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___nl",
    path: directfIc4JQFEtcMeta?.path ?? "/nl/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: directfIc4JQFEtcMeta?.name ?? "slug-direct___de",
    path: directfIc4JQFEtcMeta?.path ?? "/de/:slug()/direct",
    meta: directfIc4JQFEtcMeta || {},
    alias: directfIc4JQFEtcMeta?.alias || [],
    redirect: directfIc4JQFEtcMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/direct.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___en",
    path: indexenuCsulzJFMeta?.path ?? "/en/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___pt",
    path: indexenuCsulzJFMeta?.path ?? "/pt/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___ca",
    path: indexenuCsulzJFMeta?.path ?? "/ca/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___es",
    path: indexenuCsulzJFMeta?.path ?? "/es/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___fr",
    path: indexenuCsulzJFMeta?.path ?? "/fr/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___it",
    path: indexenuCsulzJFMeta?.path ?? "/it/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___nl",
    path: indexenuCsulzJFMeta?.path ?? "/nl/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexenuCsulzJFMeta?.name ?? "slug___de",
    path: indexenuCsulzJFMeta?.path ?? "/de/:slug()",
    meta: indexenuCsulzJFMeta || {},
    alias: indexenuCsulzJFMeta?.alias || [],
    redirect: indexenuCsulzJFMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___en",
    path: processingragpXmuMELMeta?.path ?? "/en/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___pt",
    path: processingragpXmuMELMeta?.path ?? "/pt/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___ca",
    path: processingragpXmuMELMeta?.path ?? "/ca/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___es",
    path: processingragpXmuMELMeta?.path ?? "/es/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___fr",
    path: processingragpXmuMELMeta?.path ?? "/fr/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___it",
    path: processingragpXmuMELMeta?.path ?? "/it/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___nl",
    path: processingragpXmuMELMeta?.path ?? "/nl/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: processingragpXmuMELMeta?.name ?? "slug-processing___de",
    path: processingragpXmuMELMeta?.path ?? "/de/:slug()/processing",
    meta: processingragpXmuMELMeta || {},
    alias: processingragpXmuMELMeta?.alias || [],
    redirect: processingragpXmuMELMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/processing.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___en",
    path: summarymfuZHB64tAMeta?.path ?? "/en/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___pt",
    path: summarymfuZHB64tAMeta?.path ?? "/pt/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___ca",
    path: summarymfuZHB64tAMeta?.path ?? "/ca/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___es",
    path: summarymfuZHB64tAMeta?.path ?? "/es/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___fr",
    path: summarymfuZHB64tAMeta?.path ?? "/fr/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___it",
    path: summarymfuZHB64tAMeta?.path ?? "/it/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___nl",
    path: summarymfuZHB64tAMeta?.path ?? "/nl/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  },
  {
    name: summarymfuZHB64tAMeta?.name ?? "slug-summary___de",
    path: summarymfuZHB64tAMeta?.path ?? "/de/:slug()/summary",
    meta: summarymfuZHB64tAMeta || {},
    alias: summarymfuZHB64tAMeta?.alias || [],
    redirect: summarymfuZHB64tAMeta?.redirect,
    component: () => import("/tmp/build/d411e185/code/pages/[slug]/summary.vue").then(m => m.default || m)
  }
]